var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsAdjust(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 4.5H14.5687C14.2875 3.20625 13.1625 2.25 11.8125 2.25C10.4625 2.25 9.3375 3.20625 9.05625 4.5H1.125V5.625H9.05625C9.3375 6.91875 10.4625 7.875 11.8125 7.875C13.1625 7.875 14.2875 6.91875 14.5687 5.625H16.875V4.5ZM11.8125 6.75C10.8562 6.75 10.125 6.01875 10.125 5.0625C10.125 4.10625 10.8562 3.375 11.8125 3.375C12.7688 3.375 13.5 4.10625 13.5 5.0625C13.5 6.01875 12.7688 6.75 11.8125 6.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 13.5H3.43125C3.7125 14.7937 4.8375 15.75 6.1875 15.75C7.5375 15.75 8.6625 14.7937 8.94375 13.5H16.875V12.375H8.94375C8.6625 11.0813 7.5375 10.125 6.1875 10.125C4.8375 10.125 3.7125 11.0813 3.43125 12.375H1.125V13.5ZM6.1875 11.25C7.14375 11.25 7.875 11.9812 7.875 12.9375C7.875 13.8937 7.14375 14.625 6.1875 14.625C5.23125 14.625 4.5 13.8937 4.5 12.9375C4.5 11.9812 5.23125 11.25 6.1875 11.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsAdjust);
export default __webpack_public_path__ + "static/media/settings-adjust.077d0ec0975eb5f5a05c0237a7d9af42.svg";
export { ForwardRef as ReactComponent };